import type { FunctionComponent } from 'react';
import { useEffect } from 'react';

import { forTemplate } from '@trello/i18n';
import { Button } from '@trello/nachos/button';

import styles from './CardBackLoadingError.less';

// eslint-disable-next-line @trello/assets-alongside-implementation
import tacoSleepSvg from 'resources/images/taco-sleep.svg';

const formatError = forTemplate('error');
const formatConnectFailed = forTemplate('connect_failed');

interface CardBackLoadingErrorProps {
  onClose?: () => void;
}

const reloadPage = () => window.location.reload();

export const CardBackLoadingError: FunctionComponent<
  CardBackLoadingErrorProps
> = (props) => {
  useEffect(() => {
    const windowHolder = document.querySelector<HTMLElement>('.window');
    if (windowHolder !== null) {
      windowHolder.style.display = 'block';
      document.body.classList.add('window-up');
    }

    return () => {
      if (windowHolder !== null) {
        windowHolder.style.display = 'none';
        document.body.classList.remove('window-up');
      }
    };
  });

  return (
    <div className={`${styles.errorMessage}`}>
      <button
        className={'icon-md icon-close dialog-close-button js-close-window'}
        onClick={props.onClose}
      />
      <div className={'u-clearfix'}>
        <img alt="Taco" src={tacoSleepSvg} />
        <h4 id="js-dialog-title">{formatError('card-detail-loading-error')}</h4>
        <p>{formatError('reload-call-to-action')}</p>
        <Button appearance={'primary'} onClick={reloadPage}>
          {formatConnectFailed('reload-page')}
        </Button>
      </div>
    </div>
  );
};
